import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import messages from '../messages';
import { SignUpContainer, SignUpLink, SignUpTitleSection } from './SignupStyles';

const SignUpSuccessContainer = styled(SignUpContainer)`
  align-items: center;
`;

const SignUpBackToLinkText = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  margin-top: 12px;
`;

const SignupSuccess = () => {
  return (
    <SignUpSuccessContainer>
      <SignUpTitleSection>
        <FormattedMessage {...messages.accountSignUpSuccess} />
      </SignUpTitleSection>

      <SignUpBackToLinkText>
        <FormattedMessage {...messages.backToLink} />{' '}
        <SignUpLink href={`${process.env.APP_WMS_URL}/customers?tab=requested-customer`}>WMS</SignUpLink>
      </SignUpBackToLinkText>
    </SignUpSuccessContainer>
  );
};

export default SignupSuccess;
